module.exports = __webpack_public_path__ + "img/1970East-020_WEB-min.49d9d4f8.jpg";